#!/usr/bin/env node

import chalk from "chalk"
import { Command } from "commander"
import { create } from "./commands/create.js"
import { version } from "./utils/version.js"

const program = new Command()

program
  .name("create-frontend-app")
  .description(
    "Interactive CLI wizard for scaffolding modern frontend projects",
  )
  .version(version)
  .option("-d, --debug", "enable debug mode")
  .option("-p, --preset <preset>", "use a preset configuration")
  .option("--dry-run", "perform a dry run without creating files")

program.arguments("[project-name]").action(async (projectName, options) => {
  await create(projectName, options)
})

program
  .command("create [project-name]")
  .description("Create a new frontend project")
  .option(
    "-f, --framework <framework>",
    "frontend framework (react, vue, svelte, astro, vanilla)",
  )
  .option("-m, --meta <meta>", "meta framework (next, remix, sveltekit, nuxt)")
  .option("--ts, --typescript", "use TypeScript")
  .option("--no-ts, --no-typescript", "use JavaScript")
  .option("--tailwind", "add Tailwind CSS")
  .option("--no-tailwind", "skip Tailwind CSS")
  .option("--pm <manager>", "package manager (npm, pnpm, yarn, bun)")
  .option("--quality <tool>", "code quality tool (biome, eslint-prettier)")
  .option("--git-hooks", "add Lefthook for Git hooks")
  .action(create)

program
  .command("list-presets")
  .description("List available presets")
  .action(() => {
    console.log(chalk.cyan("\n📋 Available Presets:\n"))
    console.log(
      "  • next-app       - Next.js with TypeScript, Tailwind, and Biome",
    )
    console.log("  • vue-minimal    - Vue with JavaScript and ESLint")
    console.log("  • svelte-kit     - SvelteKit with TypeScript and Biome")
    console.log("  • astro-blog     - Astro with TypeScript and Tailwind")
    console.log("  • react-vite     - React with Vite, TypeScript, and Biome\n")
  })

program.parse(process.argv)

if (!process.argv.slice(2).length) {
  program.outputHelp()
}
